module.exports = __webpack_public_path__ + "static/media/security_cafe.b9001aae.jpeg";